import { render, staticRenderFns } from "./GraficoPercentual.vue?vue&type=template&id=c88b4fee"
import script from "./GraficoPercentual.vue?vue&type=script&lang=js"
export * from "./GraficoPercentual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports